export { };

declare global {
    interface Array<T> {
        includes(searchElement: T): boolean;
        sum(prop: string): number;
        remove(item: T | Predicate<T>): Array<T>;
        insert(item: T, index?: number): Array<T>;
    }

    interface String {
        startsWith(str: string): boolean;
        includes(): boolean;
        isEmptyGuid(): boolean
    }

    interface Object {
        newGuid(): String;
    }

    type Predicate<T> = (item: T) => boolean;
}

/*
    IE Doesn't have a .startsWith either?
    */
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str: string) {
        'use strict';
        return this.lastIndexOf(str, 0) === 0;
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

if (!Array.prototype.sum) {
    Array.prototype.sum = function (prop: string) {
        'use strict';
        var total = 0;
        for (let i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop];
        }
        return total;
    };
}

if (!Array.prototype.remove) {
    Array.prototype.remove = function (itemOrFunc: Predicate<any> | Object) {
        'use strict';
        var arr = this;
        if (typeof itemOrFunc === 'function') {
            let func = itemOrFunc as Function;
            for (var i = arr.length; i--;) {
                if (func(arr[i])) {
                    arr.splice(i, 1);
                }
            }
        } else {
            'use strict';
            var arr = this;
            let item = itemOrFunc as Object;
            for (var i = arr.length; i--;) {
                if (arr[i] === item) {
                    arr.splice(i, 1);
                }
            }
            return arr;
        }
        return arr;
    };
}


if (!Array.prototype.insert) {
    Array.prototype.insert = function (item: any, index?: number) {
        let pos = index || 0
        this.splice(pos, 0, item);
        return this;
    };
}

if (!Object.newGuid) {

    Object.newGuid = function generateGuid() {
        var result: string;
        let i, j: number;

        result = '';
        for (j = 0; j < 32; j++) {
            if (j == 8 || j == 12 || j == 16 || j == 20)
                result = result + '-';
            i = Math.floor(Math.random() * 16).toString(16).toUpperCase();
            result = result + i;
        }
        return result.toLowerCase();
    }


    if (!String.prototype.isEmptyGuid) {
        String.prototype.isEmptyGuid = function generateGuid() {
            var test = this;
            return '00000000-0000-0000-0000-000000000000' == test;
        }
    }

}





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/polyfills.ts